import { Guid } from "guid-typescript";
import { CategoriaPessoaJuridica } from "src/app/enums/pessoa-enums/categoria-pessoa-juridica.enum";
import { NaturezaPessoa } from "src/app/enums/pessoa-enums/natureza-pessoa.enum";

export class Pessoa {
  id: undefined;
  nome: string = "";
  nickname: string = "";
  email: string = "";
  cpfCnpj: string = "";
  tipo: string = "";
  grupo: string = "";
  unidadeNegocioId?: Guid = null;
  grupoId?: Guid = null;
  naturezaPessoa?: NaturezaPessoa = NaturezaPessoa.Fisica;
  categoriaPessoaJuridica?: CategoriaPessoaJuridica =
    CategoriaPessoaJuridica.Matriz;
  codigoCliente: string = "";
  numeroProcessoSequencial: string = "";
  gruposBU: any [] = [];
  cartaoCNPJ:string;

  pessoaDados: PessoaDados[] = [];

  GetPessoaDados(pessoa: Pessoa, chave: String) {
    var pessoaDados = pessoa.pessoaDados.filter(function filter(
      element,
      index,
      array
    ) {
      return element.nome == chave;
    });

    if (pessoaDados != null) {
      return pessoaDados;
    }
    return null;
  }

  GetPessoaDadosComplementar(pessoaDados: PessoaDados, chave: String) {
    var pessoaDadosComplemetar = pessoaDados.pessoaDadosComplementares.find(
      (x) => x.nome == chave
    );

    if (pessoaDadosComplemetar != null) {
      return pessoaDadosComplemetar;
    }
    return null;
  }
}

export class PessoaDados {
  id: undefined;
  pessoaId: undefined;
  nome: String = "";
  nickname: String = "";
  valor: String = "";
  pessoaDadosComplementares: PessoaDadosComplementares[] = [];
}

export class PessoaDadosComplementares {
  id: undefined;
  pessoaDadosId: undefined;
  nome: String = "";
  nickname: String = "";
  valor: String = "";
}


export interface GrupoBUResponse {
    id: string;
    codExterno: number;
    nickname: string;
    nome: string;
    displayName: string;
    categoriaPessoaJuridica: number;
  }
